import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
    Box,
    Button,
    List,
    ListItemButton,
    ListItemText,
} from "@mui/material/";

import { useAssetTypeImageTypes } from "../common/hooks";
import useImageTypes from "../common/components/PhotoList/useImageTypes";
import useImageType from "../common/components/NativeCamera/useImageType";
import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles";

import AppModal from "../common/components/AppModal";

/*
 * Temporary solution to support transition from
 * Browser camera to Native camera
 * Should be removed once Native camera proofs itself
 */

const ImageTypeModal = ({ open, setOpen, assetTypeId, hdlItemSelection }) => {
    const { t } = useTranslation();
    const classes = makeStyles(styles)();

    const assetImageTypes = useAssetTypeImageTypes(assetTypeId);
    const imageTypes = useImageTypes(assetImageTypes, 0);

    return (
        <AppModal
            isVisible={open}
            title={t("imageType")}
            onClose={() => setOpen(false)}
        >
            <List
                className={classes.list}
                component="nav"
                aria-labelledby="nested-list-subheader"
            >
                {imageTypes.map((item) => {
                    return (
                        <ListItemButton
                            key={item.id}
                            className={classes.listItemBtn}
                            onClick={hdlItemSelection(item.id)}
                        >
                            <ListItemText primary={item.name} />
                        </ListItemButton>
                    );
                })}
            </List>
        </AppModal>
    );
};

export default ImageTypeModal;
